import { render, staticRenderFns } from "./ArtXlsElement.vue?vue&type=template&id=2704fb82&scoped=true&"
import script from "./ArtXlsElement.vue?vue&type=script&lang=js&"
export * from "./ArtXlsElement.vue?vue&type=script&lang=js&"
import style0 from "./ArtXlsElement.vue?vue&type=style&index=0&id=2704fb82&scoped=true&lang=scss&"
import style1 from "./ArtXlsElement.vue?vue&type=style&index=1&id=2704fb82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2704fb82",
  null
  
)

export default component.exports